import { createAsyncThunk } from "@reduxjs/toolkit";
import { FileHolder } from "../../../@types/fileHolder";
import axios from "axios";
import api from "../../../utils/api";
import { UserPhoto } from "../../../@types/usePhotoGallery";
import axiosInstance from "../../../utils/axiosConfig";

export const sendFile = createAsyncThunk(
  "uploadDocument",
  async (fileToUpload: FileHolder[], { rejectWithValue }) => {
    let fileIds: number[] = [];
    fileIds.push(fileToUpload[0].id);

    if (fileToUpload.length > 0) {
      const formData = new FormData();
      formData.append("file", fileToUpload[0].file);

      // Obtén el token desde localStorage
      const token = localStorage.getItem('token');

      // Enviar archivo
      const { data: dataResponse } = await axiosInstance.post(
        `${api.baseURL}archive`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Actualizar archivo
      await axiosInstance.patch(
        `${api.baseURL}archive/upload?idArchive=${dataResponse.id}&idCompliance=${fileToUpload[0].id}&idUser=${fileToUpload[0].userId}&expirationDate=`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }

    return fileIds;
  }
);

export const sendPhoto = createAsyncThunk(
  "uploadPhoto",
  async (fileToUpload: UserPhoto[], { rejectWithValue }) => {
    let fileIds: number[] = [];
    fileIds.push(fileToUpload[0].category!);

    if (fileToUpload.length > 0) {
      let imageToBlob = await fetch(fileToUpload[0].webviewPath!).then((r) => r.blob());

      var file = new File([imageToBlob], fileToUpload[0].filepath, {
        type: "image/jpeg",
      });

      const formData = new FormData();
      formData.append("file", file);

      // Obtén el token desde localStorage
      const token = localStorage.getItem('token');

      // Enviar archivo
      const { data: dataResponse } = await axiosInstance.post(
        `${api.baseURL}archive`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Actualizar archivo
      await axiosInstance.patch(
        `${api.baseURL}archive/upload?idArchive=${dataResponse.id}&idCompliance=${fileToUpload[0].category}&idUser=${fileToUpload[0].userId}&expirationDate=`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }

    return fileIds;
  }
);